<template>
  <!--srcviewscompanylistriskvuehtmlStart-->
  <div>
    <div
      id="defaultId1"
      class="uedbd2"
      style="display: flex; height: 100%; background: #f5f5f5"
    >
      <div
        style="transition: 0.2s"
        :class="$store.state.app.isMenu ? '' : 'hidemenu'"
        v-loading="RiskLoding"
      >
        <div style="height: 99%; padding-bottom: 11%">
          <div :class="!this.Compare ? '' : 'vague'" style="height: 98%">
            <div class="left_menu margin-top30" style="height: 98%">
              <div class="FilterQuestion">
                <div class="left_menu_question">
                  <div class="table">
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("SearchTrade.TransactionDate") }}
                        <span class="Clear_all" @click="clearAllTags">
                          <i
                            class="iconfont icon-qingchu"
                            style="color: #ff6a6a; margin-right: 5px"
                          ></i>
                          {{ $t("SearchTrade.ClearAll") }}
                        </span>
                      </p>

                      <el-select
                        clearable
                        filterable
                        @change="ChangeRadio"
                        v-model="datePickerYear"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        :placeholder="$t('SearchTrade.SelectTransactionDate')"
                      >
                        <el-option
                          v-for="item in impYearList"
                          :key="item"
                          :label="item"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("SearchTrade.Country") }}
                      </p>

                      <el-select
                        filterable
                        v-model="CountryListCode"
                        clearable
                        @change="ChangeRadio"
                        :popper-append-to-body="false"
                        style="width: 100%"
                        :placeholder="$t('SearchTrade.SelectCountry')"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in CountryList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("SearchTrade.Company") }}
                      </p>

                      <el-select
                        :popper-append-to-body="false"
                        filterable
                        @change="ChangeRadio"
                        v-model="buyerNamevalue"
                        clearable
                        style="width: 100%"
                        :placeholder="$t('SearchTrade.SelectCompany')"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in buyerNameList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                          <el-tooltip
                            effect="light"
                            :content="item.name"
                            placement="top"
                            :disabled="item?.name?.length < 24"
                          >
                            <span
                              style="
                                display: block;
                                max-width: 21rem;
                                line-height: auto;
                              "
                              class="Country_name"
                            >
                              {{ item.name }}</span
                            >
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </div>
                    <div class="left_menu_context">
                      <p class="left_menu_context-title">
                        {{ $t("SearchTrade.ProductName") }}
                      </p>

                      <el-select
                        :popper-append-to-body="false"
                        filterable
                        @change="ChangeRadio"
                        v-model="productNames"
                        clearable
                        style="width: 100%"
                        :placeholder="$t('SearchTrade.SelectProductName')"
                        class="search-select-con"
                      >
                        <el-option
                          v-for="item in productNamesList"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        >
                          <el-tooltip
                            effect="light"
                            :content="item.name"
                            placement="top"
                            :disabled="item?.name?.length < 24"
                          >
                            <span
                              style="
                                display: block;
                                max-width: 21rem;
                                line-height: auto;
                              "
                              class="Country_name"
                            >
                              {{ item.name }}</span
                            >
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="cc5f49"
        :class="
          $store.state.app.isMenu
            ? 'scrollbar scrollbar_right'
            : ' scrollbar scrollbar_right udb507two'
        "
      >
        <div style="height: 100%" v-loading="RiskLoding">
          <div class="list-label" v-show="!Compare" style="height: 100%">
            <div
              id="c6d65e"
              class="trade_bottom_right_top Alchecked flex_center_bettwen"
              style="padding-left: 20px; align-items: center"
            >
              <div>
                <el-checkbox
                  v-if="isOpenSlct"
                  style="margin-right: 20px"
                  id="c0b733"
                  v-model="checked"
                  label
                  @change="changeSlctAll"
                  >All</el-checkbox
                >
              </div>
            </div>
            <div class="flex_center margin-bottom20">
              <ul class="flex_center Data-Management-ul">
                <li
                  v-for="(item, index) in managementMenu"
                  @click="
                    (item.value == 2 ? suppliersFlag : buyersFlag)
                      ? MenuClick(item)
                      : ''
                  "
                  :class="
                    (menuActive == item.value
                      ? 'menuActiveColor font18 font_bold'
                      : 'font18') +
                    '  ' +
                    ((item.value == 2 ? suppliersFlag : buyersFlag)
                      ? ''
                      : 'cuspointno')
                  "
                  :key="index"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>

            <h3 class="operations-head-content">
              <span
                class="operations-head font1A2332 font_bold"
                v-if="menuActive == 1"
              >
                {{ $t("SearchTrade.BuyerOverview") }}</span
              >
              <span class="operations-head font1A2332 font_bold" v-else>
                {{ $t("SearchTrade.SupplierOverview") }}</span
              >
            </h3>

            <div
              class="flex_center_between_box"
              style="width: 100%; height: 98%"
            >
              <div class="risk-center-list">
                <div>
                  <ul>
                    <draggable
                      filter=".forbid"
                      v-model="CompanyList"
                      :disabled="disabled"
                      animation="300"
                      :move="onMove"
                    >
                      <transition-group>
                        <li
                          v-for="(item, index) in CompanyList"
                          :key="index"
                          class="conpany-center-list forbid item"
                          :class="{
                            iconbgActiveBG: NationalIndustryActive == index,
                          }"
                          style="position: relative"
                        >
                          <div class="flex_between_box">
                            <div
                              :class="
                                NationalIndustryActive == index
                                  ? 'ListLeftActive'
                                  : 'conpany-center-list-left'
                              "
                            >
                              <el-checkbox
                                v-if="isOpenSlct"
                                id="cee084"
                                style="margin-right: 10px; margin-top: 0.3rem"
                                v-model="item.isChecked"
                                label
                                @change="changeItemChecked"
                              >
                              </el-checkbox>
                              <span
                                :class="
                                  item.isDing
                                    ? 'indexPositon'
                                    : 'indexPositonactive'
                                "
                                >{{ index + 1 }}</span
                              >
                              <div class="conpany-center-list-left-box">
                                <p slot="reference">
                                  <span
                                    @click="setNews(item, 'prife')"
                                    style="
                                      font-family: 'Arial Bold';
                                      cursor: pointer;
                                    "
                                    class="CountryActive"
                                    >{{ item.companyName }}
                                  </span>
                                  <span class="margin-left20">
                                    <i
                                      class="iconfont icon-shoucang"
                                      :style="
                                        item.isFavorite
                                          ? 'color: #F56B6B !important'
                                          : 'color: #CCCCCC;'
                                      "
                                    ></i>
                                  </span>

                                  <!-- <span class="margin-left20">
                                      <i
                                        class="iconfont icon-a-lujingbeifen251 icontransform" 
                                        :class="{ rotate: item.isRotated }"
                                        @click=" !NationalIndustryShow && getCompanyDetailList(item, index)"
                                      ></i>
                                    </span> -->
                                </p>
                                <p
                                  class="list-text-color"
                                  style="color: #29445d !important"
                                >
                                  <img :src="item.flag" />{{ item.countryName }}
                                  <span
                                    class="fontDDDDDD margin-left20"
                                    v-if="item.cityName"
                                    >|</span
                                  >
                                  <span
                                    class="margin-left20"
                                    v-if="item.cityName"
                                    >{{ item.cityName }}</span
                                  >
                                  <span
                                    class="fontDDDDDD margin-left20"
                                    v-if="item.provinceName"
                                    >|</span
                                  >
                                  <span
                                    class="margin-left20"
                                    v-if="item.provinceName"
                                    >{{ item.provinceName }}</span
                                  >
                                  <span
                                    class="margin-left20"
                                    v-if="item.growthRate"
                                  >
                                    <i
                                      v-if="item.growthRate < 0"
                                      class="iconfont icon-arrowup-copy"
                                      style="color: #009ea7"
                                    ></i>
                                    <i
                                      v-else
                                      class="iconfont icon-arrowup"
                                      style="color: #ff6a6a"
                                    ></i>
                                  </span>
                                  <span v-if="item.growthRate">
                                    <span
                                      v-if="item.growthRate < 0"
                                      style="color: #009ea7"
                                      >{{ item.growthRate }}%</span
                                    >
                                    <span v-else style="color: #ff6a6a"
                                      >+{{ item.growthRate }}%</span
                                    >
                                  </span>
                                </p>
                                <el-popover
                                  :disabled="
                                    !NationalIndustryShow ||
                                    NationalIndustryActive != index
                                  "
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchTrade.CompanyID') +
                                    ':' +
                                    (item.regno == '' || item.regno == null
                                      ? '-'
                                      : item.regno) +
                                    $t('SearchTrade.ISIC') +
                                    ':' +
                                    (item.isicCode == '' ||
                                    item.isicCode == null
                                      ? '-'
                                      : item.isicCode) +
                                    $t('SearchTrade.ISICDescription') +
                                    ' :' +
                                    (item.isicen == '' || item.isicen == null
                                      ? '-'
                                      : item.isicen)
                                  "
                                >
                                  <p slot="reference" class="list-text-color">
                                    <span class="showhis">
                                      <span class="font666666">
                                        {{ $t("SearchTrade.CompanyID") }}:</span
                                      >
                                      <span v-if="item.company_country == 'CN'">
                                        {{ item.regno }}
                                      </span>
                                      <span v-else>
                                        {{
                                          item.regno == "" || item.regno == null
                                            ? item.regno
                                            : item.regno
                                        }}</span
                                      >
                                      <span class="fontDDDDDD margin-left20"
                                        >|</span
                                      >
                                      <span class="font666666 margin-left20">
                                        {{ $t("SearchTrade.ISIC") }}:</span
                                      >
                                      <span>{{ item.isicCode }}</span>
                                      <span class="fontDDDDDD margin-left20"
                                        >|</span
                                      >
                                      <span class="font666666 margin-left20">
                                        {{ $t("SearchTrade.ISICDescription") }}:
                                      </span>
                                      <el-popover
                                        :disabled="NationalIndustryShow"
                                        placement="top"
                                        trigger="hover"
                                        popper-class="table_popover"
                                        :content="item.isicen"
                                      >
                                        <span slot="reference">
                                          {{ item.isicen }}
                                        </span>
                                      </el-popover>
                                    </span>
                                  </p>
                                </el-popover>
                                <el-popover
                                  :disabled="
                                    !NationalIndustryShow ||
                                    NationalIndustryActive != index
                                  "
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchTrade.TransactionDate') +
                                    ':' +
                                    (item.lastTradeDate == '' ||
                                    item.lastTradeDate == null
                                      ? '-'
                                      : item.lastTradeDate) +
                                    $t('SearchTrade.TotalTradeAnnual') +
                                    ':' +
                                    (item.sumTransactions == '' ||
                                    item.sumTransactions == null
                                      ? '-'
                                      : item.sumTransactions) +
                                    $t('SearchTrade.TotalTradePastsixmonth') +
                                    ':' +
                                    (item.nearSixTransactions == '' ||
                                    item.nearSixTransactions == null
                                      ? '-'
                                      : item.nearSixTransactions)
                                  "
                                >
                                  <p slot="reference" class="list-text-color">
                                    <span class="showhis">
                                      <span class="font666666">
                                        {{ $t("SearchTrade.TransactionDate") }}:
                                      </span>
                                      <span> {{ item.lastTradeDate }}</span>
                                      <span class="fontDDDDDD margin-left20"
                                        >|</span
                                      >
                                      <span class="margin-left20 font666666">
                                        {{
                                          $t("SearchTrade.TotalTradeAnnual")
                                        }}:
                                      </span>
                                      <span>
                                        {{
                                          item.sumTransactions | FormatNum
                                        }}</span
                                      >
                                      <span class="fontDDDDDD margin-left20"
                                        >|</span
                                      >
                                      <span class="margin-left20 font666666">
                                        {{
                                          $t(
                                            "SearchTrade.TotalTradePastsixmonth",
                                          )
                                        }}
                                      </span>
                                      <span>
                                        {{
                                          item.nearSixTransactions | FormatNum
                                        }}</span
                                      >
                                    </span>
                                  </p>
                                </el-popover>
                                <p
                                  class="list-text-color pTop5"
                                  style="align-items: flex-start"
                                >
                                  <span
                                    class="font666666 txtTop5"
                                    v-if="menuActive == 1"
                                  >
                                    {{ $t("SearchTrade.TopExportProducts") }}:
                                  </span>
                                  <span class="font666666 txtTop5" v-else>
                                    {{ $t("SearchTrade.TopImportProducts") }}:
                                  </span>
                                  <span
                                    class="pTop5Right"
                                    ref="productsContainer"
                                    :class="{
                                      MainProductsMainProducts:
                                        item.MainProductsShow &&
                                        (!item.showMore ||
                                          NationalIndustryShow),
                                    }"
                                  >
                                    <el-popover
                                      v-for="(ite, index) in item.products"
                                      placement="top"
                                      trigger="hover"
                                      popper-class="table_popover"
                                      :content="ite?.name"
                                    >
                                      <span
                                        class="MainProducts margin-right10 font16"
                                        slot="reference"
                                        :key="index"
                                        >{{ ite.name }}
                                      </span>
                                    </el-popover>
                                  </span>
                                  <span
                                    ref="productsShowMore"
                                    class="MainProductsAll"
                                    v-if="
                                      item?.products?.length > 1 &&
                                      !item.showMore &&
                                      !NationalIndustryShow
                                    "
                                    @click="
                                      item.MainProductsShow =
                                        !item.MainProductsShow
                                    "
                                    >...</span
                                  >
                                </p>
                              </div>
                            </div>
                            <div class="conpany-center-list-right">
                              <p>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchTrade.ContactInformation')
                                  "
                                >
                                  <span
                                    slot="reference"
                                    class="iconbg flex_center"
                                  >
                                    <i
                                      @click="exportCompanyWeb(item)"
                                      class="iconfont icon-dianhuaheshi"
                                      style="color: #009ea7"
                                    >
                                    </i>
                                  </span>
                                </el-popover>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchLeadsList.SupplyChainList')
                                  "
                                >
                                  <button
                                    slot="reference"
                                    class="margin-left20 iconbg flex_center"
                                    @click="exportCompanyImport(item)"
                                  >
                                    <i
                                      class="iconfont icon-gongyinglianyunyingnengli"
                                      style="color: #009ea7"
                                    >
                                    </i>
                                  </button>
                                </el-popover>
                                <el-popover
                                  placement="top"
                                  trigger="hover"
                                  popper-class="table_popover"
                                  :content="
                                    $t('SearchTrade.TradeHistoryandTrends')
                                  "
                                >
                                  <span
                                    slot="reference"
                                    class="margin-left20 iconbg flex_center"
                                    :class="{
                                      iconbgActive:
                                        NationalIndustryActive == index,
                                    }"
                                  >
                                    <i
                                      v-if="NationalIndustryActive == index"
                                      @click="NationalIndustry(item, index)"
                                      class="iconfont icon-qushi"
                                      style="color: #ffffff"
                                    ></i>
                                    <i
                                      v-else
                                      @click="NationalIndustry(item, index)"
                                      class="iconfont icon-qushi"
                                      style="color: #009ea7"
                                    ></i>
                                  </span>
                                </el-popover>
                              </p>
                            </div>
                          </div>
                          <transition name="fade">
                            <div
                              class="flex_box bottom-list-echarts margin-top20 margin-left30"
                              v-show="item.isRotated"
                            >
                              <div class="bottom-list-echarts-li">
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchTrade.RegistrationDate')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.RegistrationDate")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.legalStatus
                                            ?.registerDate
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.Profit") }}</span
                                      >
                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.profit?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          $t('SearchTrade.NoofShareholders')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.NoofShareholders")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.current?.shareholds
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="$t('SearchTrade.TotalAssets')"
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.TotalAssets")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.asset?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.asset
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.financialStatus
                                            ?.asset
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchTrade.IndustryCode")
                                        }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.current?.industryCode
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchTrade.CreditRating")
                                        }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.creditRating
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <el-tooltip
                                        effect="light"
                                        :visible-arrow="true"
                                        :content="
                                          $t('SearchTrade.NoofEmployees')
                                        "
                                        placement="top"
                                      >
                                        <span class="profit-txt">
                                          {{
                                            $t("SearchTrade.NoofEmployees")
                                          }}</span
                                        >
                                      </el-tooltip>

                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.current?.employee
                                          | FilterNum
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{
                                          $t("SearchTrade.CreditScore")
                                        }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.creditScore
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.Listed") }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.legalStatus?.listed
                                      }}</span>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.ESGRating") }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings
                                          ?.ratingESG
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex_center_between_box">
                                  <div
                                    class="bottom-list-echarts-li-left flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.Revenue") }}</span
                                      >
                                      <el-tooltip
                                        :disabled="
                                          item.prifeTeable?.financialStatus
                                            ?.profit?.length < 10
                                        "
                                        class="line_1"
                                        effect="light"
                                        :visible-arrow="false"
                                        :content="
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        "
                                        placement="top"
                                      >
                                        <span class="Color009EA7">{{
                                          item.prifeTeable?.financialStatus
                                            ?.profit
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </div>
                                  <div
                                    class="bottom-list-echarts-li-right flex_center_between_box"
                                  >
                                    <div
                                      class="bottom-list-echarts-li-left-text flex_center_between_box"
                                    >
                                      <span class="profit-txt">
                                        {{ $t("SearchTrade.DQI") }}</span
                                      >
                                      <span class="Color009EA7 line_1">{{
                                        item.prifeTeable?.creditRatings?.dqi
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  @click="setNews(item, 'prife')"
                                  class="MoreCompany margin-top20"
                                >
                                  {{ $t("SearchTrade.MoreCoDetails") }}
                                </div>
                              </div>
                              <div class="bottom-list-echarts-li">
                                <div
                                  ref="ImportEchart"
                                  style="width: 100%; height: 210px"
                                ></div>
                              </div>
                              <div class="bottom-list-echarts-li">
                                <p class="bottom-list-echarts-head">
                                  {{ $t("SearchTrade.CoNews") }}
                                </p>
                                <ul class="margin-bottom10">
                                  <li
                                    class="flex_center_between_box"
                                    v-for="(ite, index) in item.NewstableData"
                                    :key="index"
                                  >
                                    <el-tooltip
                                      class="item"
                                      effect="light"
                                      :visible-arrow="false"
                                      :content="ite.titleEn"
                                      placement="top"
                                      :disabled="ite.titleEn?.length < 35"
                                    >
                                      <div
                                        @click="setid(ite)"
                                        class="news-text"
                                      >
                                        {{ ite.titleEn }}
                                      </div>
                                    </el-tooltip>

                                    {{ ite.date }}
                                  </li>
                                </ul>
                                <div
                                  @click="setNews(item, 'news')"
                                  v-if="item.NewstableData?.length > 6"
                                  class="MoreCompany margin-top10"
                                >
                                  {{ $t("SearchTrade.MoreCoNews") }}
                                </div>
                              </div>
                            </div>
                          </transition>
                          <div
                            :class="{ 'margin-top20': item.isRotated }"
                            :style="{ height: item.isRotated ? '10px' : '0px' }"
                          ></div>
                          <i
                            class="iconfont icon-jiantouxia icon_sanjiaoLocation"
                            :class="{ rotate: item.isRotated }"
                            @click="
                              !NationalIndustryShow &&
                                getCompanyDetailList(item, index)
                            "
                          ></i>
                        </li>
                      </transition-group>
                    </draggable>
                  </ul>
                  <div
                    class="ShowAll flex_center font18 margin-top20"
                    v-if="page.pageSize < page.total"
                    @click="ShowAll"
                  >
                    {{ $t("SearchTrade.ShowAll") }}
                  </div>
                </div>
              </div>
              <!-- NationalIndustryActive -->
              <div
                class="risk-right"
                v-if="NationalIndustryShow"
                :style="{ marginTop: calculateMarginTop() + 'px' }"
              >
                <div class="flex_center_between_box margin-bottom20">
                  <p style="font-family: Arial Bold; margin-bottom: 0px">
                    {{ $t("SearchTrade.TradeHistoryandTrends") }}
                  </p>
                  <div class="flex_center">
                    <i
                      class="iconfont icon-cuowu"
                      @click="rifghtUpdate()"
                      style="color: #1a2332"
                    ></i>
                  </div>
                </div>
                <!-- <el-date-picker
                  v-model="datePicker"
                  class="trade_date_picker"
                  @change="getgetTradeTrends()"
                  type="monthrange"
                  range-separator=""
                  :start-placeholder="$t('SearchTrade.Startdate')"
                  value-format="yyyy-MM"
                  :end-placeholder="$t('SearchTrade.Enddate')"
                ></el-date-picker> -->\

                <div>
                  <div v-show="false">{{ calDate }}</div>
                  <el-date-picker
                    class="trade_date_picker"
                    v-model="beginDate"
                    type="month"
                    :placeholder="$t('SearchTrade.Startdate')"
                    value-format="yyyy-MM"
                    :picker-options="beginPickerOptions"
                    @change="getgetTradeTrends()"
                  />
                  <span class="font16 margin-left15 margin-right15">To</span>
                  <el-date-picker
                    class="trade_date_picker"
                    v-model="endDate"
                    type="month"
                    :placeholder="$t('SearchTrade.Enddate')"
                    value-format="yyyy-MM"
                    :picker-options="endPickerOptions"
                    @change="getgetTradeTrends()"
                  />
                </div>
                <div class="margin-top30">
                  <div
                    ref="SupplyChainEchart"
                    style="width: 100%; height: 33rem"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <ContactInformation
      :ContactObj="ContactInfo"
      :suoClose="ContactIn"
      @closeCloseDialog="clossuoDialog($event)"
    ></ContactInformation>
    <SupplyChainList
      :ContactObj="ContactInfo"
      :suoClose="SupplyChain"
      @clossuoDialogtwo="clossuoDialogtwo($event)"
      btnColor="#009ea7"
      :PCM="PCMoudele"
    ></SupplyChainList>
  </div>
  <!--srcviewscompanylistriskvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import draggable from "vuedraggable";
import { findPartnerDetail } from "@/api/searchApi.js";
import ContactInformation from "../../TradeProduct/ContactInformation.vue";
import SupplyChainList from "../../TradeProduct/SupplyChainList.vue";
import { formatNum } from "@/views/company/details/Background/utils";

import Login from "@/components/login.vue";
import { getTabListOneLayer } from "@/api/userApi.js";
import {
  getCompanyIndustryInfo,
  getCompanyDetail,
  getPdfLink,
  leadsPostFilter,
  getsearchExport,
  getHuokePartPrivilege,
  searchMoreEmail,
  getTradeTrends,
  getSuppliersAndBuyersList,
  getSuppliersAndBuyersFilter,
} from "@/api/companyApi.js";
import { mixins1 } from "@/mixins/index";
export default {
  name: "",
  props: {},
  watch: {},

  mixins: [mixins1],
  components: {
    draggable,
    Login,
    ContactInformation,
    SupplyChainList,
  },

  data() {
    return {
      PCMoudele: [],
      datePickerYear: "",
      ContactIn: false,
      SupplyChain: false,
      LastUpdate: "",
      datePicker: ["2025-01", "2025-12"],
      loginDialog: false,
      ContactInfo: {
        aaa_id: "",
        web_site: "",
        company_country: "",
        file_name: "",
      },
      Compare: false,
      supplierNamevalue: "",
      supplierNameList: [],
      Improtradio: "",
      buyerNameList: [],
      buyerNamevalue: "",
      isShowTooltip: false,
      RiskLoding: false,

      MainProductsShow: "",
      json_fields: {
        companyTag: "companyTag",
        department: "department",
        email: "email",
        name: "name",
        phone: "phone",
        position: "position",
        linkedin: "linkedin",
      },
      json_fieldsImport: {
        Date: "ie_date",
        Products: "hscode_description_inter",
        "Buyer Names": "import_name",
        Destination: "import_country_inter",
        "Supplier Names": "export_name",
        Origin: "export_country_inter",
        Amount: "amount",
      },
      menuActive: 2,
      importGrowthRateTrendList: [],
      importTrendListEcharts: [],

      compareList: [],
      totle: 0,
      checked: "",
      pageNo: 1,
      disabled: false,
      NationalIndustryActive: "null",
      isRotated: false,

      NationalIndustryShow: false,

      isOpenSlct: false,

      checkList: [],
      aaaid: "",

      CompanyList: [],
      parentTable: [],
      token: localStorage.getItem("token"),
      Saved: undefined,
      isChecked: "",
      DetailsFormImportlist: [],
      riskTotal: "",
      QuestionPageList: [],

      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      chageItIndex: 0,
      chageItTrue: false,

      IndustryCode: "",
      IndustryCodeList: [],
      CountryList: "",
      CountryListCode: "",
      productNamesList: [],
      productNames: "",
      impYearList: [],

      openListIndex: null,

      suppliersFlag: false,
      buyersFlag: false,
      originFlag: false,
      destinationFlag: false,
      importFlag: false,
      exportFlag: false,

      beginDate: "",
      endDate: "",
      beginPickerOptions: {
        disabledDate: (time) => {
          if (!this.endDate) return false;
          return time.getTime() > new Date(this.endDate).getTime();
        },
      },

      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.beginDate) return false;
          return time.getTime() < new Date(this.beginDate).getTime();
        },
      },
    };
  },
  methods: {
    getgetTabListOneLayerLsit() {
      getTabListOneLayer({
        aaaId: this.$route.query.id3a,
        moduleId: 900,
      }).then((res) => {
        if (res.code == 200) {
          this.suppliersFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_suppliers",
          ).isShow;
          this.buyersFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_buyers",
          ).isShow;
          this.originFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_origin",
          ).isShow;
          this.destinationFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_destination",
          ).isShow;
          this.importFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_import_products",
          ).isShow;
          this.exportFlag = res.data.find(
            (item) => item.name == "company_trade_ranking_export_products",
          ).isShow;

          this.menuActive = this.suppliersFlag ? 2 : 1;
          var arr = {
            value: this.menuActive,
          };
          this.MenuClick(arr);
        }
      });
    },

    CloseListExpandInfo(index = null) {
      if (this.openListIndex !== null) {
        const prevItem = this.CompanyList[this.openListIndex];
        if (prevItem) prevItem.isRotated = false;
      }

      this.openListIndex =
        index !== null && this.openListIndex !== index ? index : null;
    },

    // 获取公司详情数据
    getCompanyDetailList(item, index) {
      this.chageItTrue = true;
      let that = this;
      if (this.PCMoudele[11].hasPrivilege) {
        //为什么！！！！
        item.isFavorite = !item.isFavorite;
        item.isFavorite = !item.isFavorite;
        //为什么！！！！

        // console.log(item);
        // console.log("aaaId:"+item.aaa_id);
        // console.log("countryCode:"+item.company_country);
        // console.log("industryCode:"+item.isic_code);
        const isCurrentlyOpen = this.openListIndex === index;
        this.CloseListExpandInfo(index);
        if (!isCurrentlyOpen) {
          item.isRotated = true;
          getCompanyDetail({
            aaaId: item.aaaid,
            countryCode: item.countryCode,
            industryCode: item.isicCode,
          })
            .then((res) => {
              // 更新数据
              item.NewstableData = res.data.news;
              item.prifeTeable = res.data.snapshotVO;
              item.InsdustryTable = res.data.incomePanel.industryIncomes;
              item.companyIncomes = res.data.incomePanel.companyIncomes;

              // 图表配置
              const option = {
                tooltip: {
                  trigger: "axis",
                  axisPointer: {
                    type: "cross",
                  },
                  formatter: function (params) {
                    let result = params[0].name + "<br/>";
                    params.forEach(function (item) {
                      let formattedValue = formatNum(item.value);
                      result +=
                        item.marker +
                        item.seriesName +
                        ": " +
                        formattedValue +
                        "<br/>";
                    });
                    return result;
                  },
                },
                grid: {
                  left: "0%",
                  right: "0%",
                  top: "12%",
                  bottom: "0%",
                  containLabel: true,
                },
                legend: {
                  right: "10px",
                  top: "0px",
                },
                xAxis: [
                  {
                    type: "category",
                    data: item.companyIncomes.map((item) => item.year),
                    axisTick: {
                      show: false,
                    },
                  },
                  {
                    type: "category",
                    data: item.InsdustryTable.map((item) => item.year),
                    axisTick: {
                      show: false,
                    },
                    axisLabel: {
                      show: false,
                    },
                  },
                ],
                yAxis: [
                  {
                    type: "value",
                    axisLabel: {
                      formatter: function (value) {
                        return formatNum(value); // 格式化为千分位
                      },
                      show: false,
                    },
                    axisPointer: {
                      label: {
                        formatter: function (params) {
                          return formatNum(params.value);
                        },
                      },
                    },
                  },
                  {
                    type: "value",
                    axisLabel: {
                      formatter: function (value) {
                        return formatNum(value); // 格式化为千分位
                      },
                      show: false,
                    },
                    axisPointer: {
                      label: {
                        formatter: function (params) {
                          return formatNum(params.value);
                        },
                      },
                    },
                  },
                ],
                series: [
                  {
                    name: this.$t("SearchTrade.IndustryMean"),
                    type: "bar",
                    barWidth: "15",
                    itemStyle: { color: "#009ea7" },
                    emphasis: {
                      itemStyle: {
                        color: "#009ea7",
                      },
                    },
                    data: item.InsdustryTable.map((item) => item.income),
                  },
                  {
                    name: this.$t("SearchTrade.TargetSubjectRevenue"),
                    type: "line",
                    barWidth: "20",
                    yAxisIndex: 1,
                    itemStyle: { color: "#FF7600" },
                    emphasis: {
                      itemStyle: {
                        color: "#FF7600",
                      },
                    },
                    data: item.companyIncomes.map((item) => item.income),
                  },
                ],
              };

              // 获取图表 DOM
              const chartDom = this.$refs.ImportEchart[index];
              let chart = this.$echarts.getInstanceByDom(chartDom);

              // 如果没有找到图表实例，则初始化一个新的图表
              if (!chart) {
                chart = this.$echarts.init(chartDom);
                item.chartInstance = chart; // 存储图表实例
              } else {
                // 如果找到了图表实例，先销毁它
                chart.dispose();
                // 重新初始化图表
                chart = this.$echarts.init(chartDom);
                item.chartInstance = chart; // 更新存储的图表实例
              }

              // 设置图表选项
              this.$nextTick(() => {
                if (chart) {
                  chart.setOption(option); // 仅在 chart 存在时设置选项
                }
              });

              // 更新数据
              this.$set(item, "item.NewstableData", res.data.news);
              // this.CompanyList[index].chartInstance = chart; // 更新 CompanyList 中的图表实例
            })
            .catch((error) => {
              console.error("error:", error);
            });
        }
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },
    //新闻跳转
    setid(row) {
      if (row.link == undefined) {
        getPdfLink({ articleRef: row.id }).then((res1) => {
          // let res1 = JSON.parse(crypto.decrypt(res));

          if (res1.data?.includes("http")) {
            let routeData = res1.data;
            window.open(routeData, "_blank");
          } else {
            let routeData = "http://" + res1.data;
            window.open(routeData, "_blank");
          }
          // let routeData = res1.data;
          // window.open(routeData, '_blank');
        });
      }
      if (row.link?.includes("http")) {
        let routeData = row.link;

        window.open(routeData, "_blank");
      } else {
        let routeData = "http://" + row.link;
        window.open(routeData, "_blank");
      }
      // let routeData = row.url;
      // window.open(routeData, '_blank');
    },

    ShowAll() {
      this.page.pageSize = this.page.pageSize + 10;
      this.getSearchList();
    },
    clearAllTags() {
      this.menuActive = 2;
      this.CountryListCode = "";
      this.productNames = "";
      this.buyerNamevalue = "";
      this.datePickerYear = "";
      this.ChangeRadio();
    },

    ChangeRadio() {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = "null";
      this.page.pageSize = 10;
      this.getSuppliersAndBuyersFilterList();
      this.getSearchList();
    },
    getSuppliersAndBuyersFilterList() {
      getSuppliersAndBuyersFilter({
        countryCode: this.CountryListCode,
        tradeDim: 2,
        aaaid: this.$route.query.id3a,
        tradeCode: this.productNames,
        tradeType: this.menuActive,
        tradeYear: this.datePickerYear,
        filterAaaid: this.buyerNamevalue,
      }).then((res) => {
        if (res.code == 200) {
          this.buyerNameList = res.data.companyNames;
          this.CountryList = res.data.countryNames;
          this.productNamesList = res.data.productNames;
          this.impYearList = res.data.yearList;
        }
      });
    },
    // 获取列表数据
    getSearchList(leadsPostFilter) {
      this.RiskLoding = true;
      getSuppliersAndBuyersList({
        aaaid: this.$route.query.id3a,
        tradeType: this.menuActive,
        page: 1,
        pageSize: this.page.pageSize,
        countryCode: this.CountryListCode,
        tradeYear: this.datePickerYear,
        tradeDim: "2",
        tradeCode: this.productNames,
        filterAaaid: this.buyerNamevalue,
      }).then((res) => {
        if (res.code == 200) {
          this.RiskLoding = false;
          this.page.total = res.data.total;
          let parentTable = res.data.rows;
          parentTable.map((item, index) => {
            let countryImg = this.getCountryImgUrl(item.countryCode);
            item.MainProductsShow = false;
            if (countryImg) {
              let flag = require("../../../../../static" + countryImg);
              parentTable[index].flag = flag;

              this.refresh++;
            }
          });
          this.CompanyList = parentTable;
          // isRotated
          this.CompanyList.forEach((item) => {
            item.isRotated = false;
          });

          // 数据加载完成后检查高度
          this.$nextTick(() => {
            this.CompanyList.forEach((item, index) => {
              const container = this.$refs.productsContainer?.[index];
              if (container.offsetHeight > 38) {
                item.MainProductsShow = true;
                item.showMore = false;
              } else {
                item.showMore = true;
              }
            });
          });
        } else {
          this.RiskLoding = false;
        }
      });
    },

    clossuoDialog(value) {
      this.ContactIn = value;
    },
    clossuoDialogtwo(value) {
      console.log(`value`, value);
      this.SupplyChain = value;
    },

    suppleEchart() {
      let that = this;

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "15%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          left: "0px",
          top: "0px",
        },
        xAxis: {
          type: "category",
          data: that.importTrendListEcharts.map((item) => item.impYearMonth),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLabel: {
            rotate: -60, // 旋转角度设置为 45 度
          },
        },
        yAxis: [
          {
            type: "value",
            splitNumber: 4,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },

            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return formatNum(value); // 格式化为千分位
              },
            },
          },

          {
            type: "value",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8398BB",
              },
            },
            axisLabel: {
              show: true,
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial, Arial", // 字体类型,
              formatter: function (value) {
                return value.toLocaleString() + "%"; // 格式化为千分位
              },
              color: "#FF7600", // 这里设置颜色，比如红色
            },
          },
        ],
        series: [
          {
            name: this.$t("SearchTrade.TradeVolume"),
            type: "bar",
            barWidth: "20",
            itemStyle: { color: "#009EA7" },
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " + formatNum(value);
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.amount),
          },
          {
            name: this.$t("SearchTrade.MonthonMonthRatio"),
            type: "line",
            yAxisIndex: 1,
            itemStyle: { color: "#FF7600" },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return value + "%";
                } else {
                  return "-";
                }
              },
            },
            data: that.importTrendListEcharts.map((item) => item.growthRate),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },

    MenuClick(item) {
      this.NationalIndustryShow = false;
      this.NationalIndustryActive = null;
      this.page.pageSize = 10;
      this.menuActive = item.value;
      this.CountryListCode = "";
      this.productNames = "";
      this.buyerNamevalue = "";
      this.datePickerYear = "";
      this.ChangeRadio();
    },
    calculateMarginTop() {
      if (
        this.NationalIndustryActive === "null" ||
        this.NationalIndustryActive === null
      ) {
        return 0;
      }
      // 使用 Vue 的 refs 来获取元素（如果可能的话）
      const listContainer = document.querySelector(".risk-center-list ul");
      const listItems = document.querySelectorAll(".conpany-center-list");

      if (
        listItems.length > 0 &&
        this.NationalIndustryActive < listItems.length
      ) {
        const targetItem = listItems[this.NationalIndustryActive];

        if (targetItem && listContainer) {
          // 计算目标元素相对于列表容器的偏移量
          const containerRect = listContainer.getBoundingClientRect();
          const itemRect = targetItem.getBoundingClientRect();

          // 返回相对于容器顶部的偏移量
          return itemRect.top - containerRect.top;
        }
      }

      // 如果在 nextTick 之外执行，返回默认值
      // 实际的计算将在 nextTick 中完成
    },
    // 点击列表出现右侧数据
    NationalIndustry(item, index) {
      this.beginDate = item.yearMonthList[0];
      this.endDate = item.yearMonthList[1];

      this.CloseListExpandInfo();
      this.chageItTrue = true;
      this.NationalIndustryShow = true;
      this.NationalIndustryActive = index;
      this.datePicker = item.yearMonthList;
      this.aaaid = item.aaaid;
      this.$nextTick(() => {
        this.getgetTradeTrends();
        // 强制重新计算样式
        this.$forceUpdate();
        this.CompanyList.forEach((item, index) => {
          if (this.NationalIndustryActive == index) {
            item.MainProductsShow = true;
          }
        });
      });
    },
    getgetTradeTrends() {
      getTradeTrends({
        startMonth: this.datePicker[0],
        type: this.menuActive == 2 ? 1 : 2,
        endMonth: this.datePicker[1],
        aaaid: this.$route.query.id3a,
        aaaidFilter: this.aaaid,
      }).then((res) => {
        if (res.code == 200) {
          this.importTrendListEcharts = res.data;

          this.$nextTick(() => {
            this.suppleEchart();
          });
        }
      });
    },
    rifghtUpdate() {
      this.NationalIndustryShow = false;
      this.CompanyList.forEach((item, index) => {
        if (item.index == this.NationalIndustryActive)
          item.MainProductsShow = false;
      });
      this.NationalIndustryActive = "null";
    },
    // echarts监听 浏览器宽度改变 echarts改变

    // 获取权限
    getHuokePartPrivilegeList() {
      getHuokePartPrivilege({
        moduleType: 7,
      }).then((res) => {
        if (res.code == 200) {
          this.PCMoudele = res.data;
        }
      });
    },

    // web导出
    exportCompanyWeb(item) {
      this.ContactIn = true;
      this.ContactInfo.aaa_id = item.aaaid;

      this.ContactInfo.web_site = item.website;

      this.ContactInfo.company_country = item.countryCode;
      this.ContactInfo.file_name = item.companyName;
    },
    DetailsFormConcat() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        let params = {
          page: 1,
          pageSize: 100,
          id3a: this.aaaId,
          website: this.itemList.web_site,
          countryCode: this.itemList.company_country,
        };
        return searchMoreEmail(params).then((res) => {
          if (res.code == 200) {
            if (res.data.contacts.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.contacts;
          } else {
            return [];
          }
        });
      }
    },
    DetailsFormImport() {
      this.chageItTrue = true;
      if (this.PCMoudele[15].hasPrivilege) {
        return getsearchExport({
          page: 1,
          pageSize: 100,
          export_aaaid: this.aaaId,
          import_aaaid: this.aaaId,
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.rows.length == 0) {
              this.$message({
                message: "No Data",
                type: "success",
              });
            } else {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            return res.data.rows;
          } else {
            return [];
          }
        });
      }
    },
    // 贸易链路导出
    exportCompanyImport(item) {
      this.SupplyChain = true;
      this.ContactInfo.aaa_id = item.aaaid;

      this.ContactInfo.web_site = item.web_site;

      this.ContactInfo.company_country = item.company_country;
      this.ContactInfo.file_name = item.companyName;
    },

    // 点击跳转到贸易列表
    setNews(row, detail) {
      this.$router.push({
        path: "DetailCompany",
        query: {
          Moudles: this.$route.query.Moudles,
          idpower: this.$route.query.idpower,
          ComapnyName: row.company_name_en,
          id3a: this.$route.query.id3a,
          SACode1: this.$route.query.SACode1,
          type: this.menuActive,
          countryCode: row.countryCode,
          countryName: row.countryName,
          companyName: row.companyName,

          address: row.streetEn,
          website: row.website,
          lastTradeDate: row.lastTradeDate,
          sumTransactions: row.sumTransactions,
          sumAmount: row.sumAmount,
        },
      });
    },

    setToolsfalse() {
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 工具栏高亮控制
    setToolsAcive() {
      this.$store.dispatch("app/setTools", {
        name: "Optimize",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "filter",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true && this.token,
      });
      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true,
      });
      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: false,
      });
    },
    // 收藏

    // 获取列表数据

    // 删除元素
    DelClick(item, index) {
      if (this.PCMoudele[13].hasPrivilege) {
        this.deledeLaeadsDialog = true;
      } else {
        this.$bus.$emit("show-permission-dialog", "您没有权限访问该功能！");
      }
    },

    // 移动
    onMove(e) {
      if (e.relatedContext.element.isDing == true) return false;
      return true;
    },

    // 全选操作
    changeItemChecked(value) {
      if (this.CompanyList.filter((item) => item.isChecked).length > 0) {
        this.checked = true;
      } else {
        this.checked = false;
      }

      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.$store.dispatch("app/setchangeList", selectCompany);
      this.compareList = selectCompany;

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "collect",
        key: "isActive",
        value: selectCompany.length > 0 && this.SavyeLeadsSuo == false,
      });
      this.$store.dispatch("app/setTools", {
        name: "saved",
        key: "isActive",
        value: true && this.Compare == false,
      });

      this.$store.dispatch("app/setTools", {
        name: "compare",
        key: "isActive",
        value: this.compareList.length > 0 && this.compareList.length < 4,
      });
      this.$store.dispatch("app/setTools", {
        name: "export",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "update",
        key: "isActive",
        value: selectCompany.length > 0,
      });

      this.$store.dispatch("app/setTools", {
        name: "download",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "reportError",
        key: "isActive",
        value: false,
      });
      this.$store.dispatch("app/setTools", {
        name: "share",
        key: "isActive",
        value: selectCompany.length > 0,
      });
    },
    // 全选操作
    changeSlctAll(value) {
      this.CompanyList.forEach((item) => {
        item.isChecked = value;
      });
      let selectCompany = this.CompanyList.filter((item) => item.isChecked);
      this.compareList = selectCompany;
      this.$store.dispatch("app/setchangeList", selectCompany);
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return "highlight-cell"; // 设置你想要的背景色
      }
    },

    // setTools
    setTools() {
      this.$store.dispatch("app/setTools", {
        name: "menu",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "select",
        key: "isActive",
        value: true,
      });

      this.$store.dispatch("app/setTools", {
        name: "edit",
        key: "isActive",
        value: false,
      });

      this.$store.dispatch("app/setTools", {
        name: "sort",
        key: "isActive",
        value: false,
      });
    }, // getDetail
  },
  computed: {
    calDate() {
      this.datePicker = [this.beginDate, this.endDate];
      return this.datePicker;
    },
    managementMenu() {
      return [
        {
          label: this.$t("SearchTrade.Suppliers"),
          value: "2",
        },
        {
          label: this.$t("SearchTrade.Buyers"),
          value: "1",
        },
      ];
    },
  },
  created() {
    this.setToolsfalse();
  },
  mounted() {
    //
    this.getgetTabListOneLayerLsit();

    this.$emit("UpdatamarkTotalList", true);

    this.getSearchList();
    this.getSuppliersAndBuyersFilterList();
    this.setToolsfalse();
    if (this.token) {
      this.getHuokePartPrivilegeList();
    }
  },
  beforeDestroy() {},
};
</script>
<style scoped>
.operations-head {
  color: #009ea7;
}

.ud6279 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  margin-top: 7.642857142857143rem;
}

.u96d4d {
  width: 29rem;
}

.uba4wV3 {
  margin-right: 1.0714285714285714rem;
  margin-bottom: 0.7142857142857143rem;
  margin-top: 0.7142857142857143rem;
  margin-left: 1.0714285714285714rem;
}

.trade_bottom_right_top {
  color: #999999;
  margin-bottom: 10px;
  font-size: 16px;
  text-align: left;
  font-style: normal;
  overflow: hidden;
}

.uVwoZks {
  width: 100%;
}

.hidemenu {
  display: block;
  width: 0em;
  padding-left: 0em;
  padding-top: 0em;
  padding-bottom: 0em;
  padding-right: 0em;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.scrollbar {
  overflow: hidden;
}

.udb507two {
  width: 100%;
}

.risk-right {
  width: 540px;
  padding: 20px;
  background: #ddedee;
  height: 780px;
  border-radius: 0 10px 10px 10px;
  z-index: 999;
  position: absolute;
  right: 15px;
}

.risk-center-list {
  width: 100%;
  position: relative;
}

.Upadetime {
  font-size: 1.2857142857142858rem;
  color: #666666;
  margin-right: 2.142857142857143rem;
}

.risk-right-content {
  padding: 1.4285714285714286rem 0rem;
  border-top: 0.07142857142857142rem solid #cccccc;
}

.risk-right-content-title {
  font-size: 1.4285714285714286rem;
  color: #1a2332;
  height: 1.7142857142857142rem;
  margin-bottom: 1.4285714285714286rem;
  font-family: "Arial Bold";
}

.right-txt {
  text-align: right;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  line-height: 1.8571428571428572rem;
}

.left-txt {
  font-size: 1.2857142857142858rem;
  color: #666666;
}

.margin16 {
  margin-top: 1.1428571428571428rem;
}

.highlight-cell {
  background-color: #f2f5f9 !important;
}

.risk-right .el-table .cell {
  color: #1a2332;
}

.table-content {
  height: 3.5714285714285716rem !important;
  line-height: 3.5714285714285716rem;
}

.risk-right .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
}

.conpany-center-list {
  /* display: flex;
  justify-content: space-between; */
  padding: 30px 20px 20px;
  background: #f5f5f5;
  border-radius: 10px;
  margin-bottom: 10px;
  overflow-x: hidden;
}
.conpany-center-list.iconbgActiveBG {
  border-radius: 10px;
}

.conpany-center-list-left {
  display: flex;
  align-items: flex-start;
  width: calc(100% - 195px);
}
.ListLeftActive {
  display: flex;
  align-items: flex-start;
  width: calc(100% - 525px);
}

.conpany-center-list-leftWith {
  width: calc(100% - 195px);
}
.conpany-center-list-left-box {
  width: calc(100% - 30px);
}

.risk-center-list .el-checkbox__inner,
.Alchecked .el-checkbox__inner {
  height: 1.4285714285714286rem !important;
  width: 1.4285714285714286rem !important;
}

.conpany-center-list-left .el-checkbox__inner {
  margin-top: 0.2857142857142857rem !important;
}

.risk-center-list .el-checkbox__inner::after,
.Alchecked .el-checkbox__inner::after {
  height: 0.7142857142857143rem;
  left: 0.5rem;
}

.risk-center-list .el-checkbox__input.is-checked .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8e86dd;
  border-color: #8e86dd;
}

.risk-center-list .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked .el-checkbox__input.is-focus .el-checkbox__inner,
.Alchecked
  .el-checkbox__inner:hover
  .risk-center-list
  .el-checkbox__inner:hover {
  border: 0.07142857142857142rem solid #dcdfe6;
}

.risk-center-list .el-checkbox__input.is-checked + .el-checkbox__label,
.Alchecked .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

.indexPositon {
  margin-right: 1.4285714285714286rem;
  color: #009ea7;
  width: 1.4285714285714286rem;
}

.indexPositonactive {
  margin-right: 10px;
  color: #999999;
  width: 30px;
  font-family: "Arial Bold";
}

.list-text-color {
  font-size: 18px !important;
  color: #666666 !important;
  display: flex;
  align-items: center;
}

.list-text-color span {
  color: #1a2332;
}

.showhis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-text-color img {
  width: 36px;
  margin-right: 5px;
}

.iconbg {
  width: 50px;
  height: 50px;
  background: #ddedee;
  border-radius: 50%;
  cursor: pointer;
}
.conpany-center-list-right {
  display: flex;
  align-items: center;
}

.conpany-center-list-right p {
  font-size: 24px;
  color: #1a2332;
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.left_menu_title {
  font-size: 1.7142857142857142rem;
  color: #1a2332;
  margin: 1.4285714285714286rem 0rem;
  padding-bottom: 10px;
  border-bottom: 1px solid #dddddd;
  font-family: "Arial Bold";
}

.left_menu_question p {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 10px;
  font-family: "Arial Bold";
}

.left_menu_question .el-input__inner {
  height: 2.5714285714285716rem;
  background: #ffffff;
  border-radius: 10px;
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  padding-left: 0.7142857142857143rem !important;
}

.left_menu_question /deep/ .el-select .el-input.is-focus .el-input__inner,
.left_menu_question /deep/ .el-select .el-input__inner:focus {
  border: 0.07142857142857142rem solid #cccccc !important;

  line-height: 2.428571rem !important;
}

.left_menu_question {
  margin-bottom: 10px;
  padding-bottom: 20px;
}

.FilterQuestion .left_menu_question {
  padding-bottom: 0rem;
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5;
  border-color: #cccccc;
  color: #999999;
  line-height: 2.428571rem !important;
}

.left_menu_bottom {
  font-size: 1.1428571428571428rem;
  color: #1a2332;
  margin-bottom: 3rem;
}

.profit-txt {
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.Color009EA7 {
  text-align: right;
}

.question-detail_cont-list h3 {
  margin-top: 0.7142857142857143rem;
  font-family: Arial;
  font-weight: 400;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
}

button:disabled {
  cursor: no-drop !important;
}

.el-popover {
  padding: 10px !important;
  min-width: auto;
}

.uedbd2 {
  height: 100%;
}

.right_cont_box {
  height: 100%;
  overflow-y: auto;
}

.IElabel {
  font-size: 16px;
  color: #ff7600;
  text-align: center;
  background: #fff8f1;
  line-height: 26px;
  width: 70px;
  border-radius: 10px;
  border: 1px solid #ff7600;
}

.IElabelExport {
  background: #f4fbff;
  border-radius: 10px;
  border: 1px solid #1290c9;
  color: #1290c9;
}

.left_menu_context-title {
  font-size: 18px;
  color: #1a2332;
  font-family: "Arial Bold";
  margin-bottom: 10px;
  position: relative;
}

.left_menu_context {
  margin-bottom: 30px;
}

.trade_date_picker,
.left_menu_context /deep/ .el-input__inner {
  height: 36px !important;
  font-size: 16px;
}
.trade_date_picker {
  width: 200px;
}

/deep/ .el-radio {
  justify-content: flex-start;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #009ea7;
  font-size: 1.1428575rem;
}

/deep/ .el-radio__label {
  font-size: 1.1428575rem;
  color: #1a2332;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #009ea7;
  background: #fff;
}

/deep/ .el-radio__input.is-checked .el-radio__inner::after {
  background: #009ea7;
}
.flex_center_between_box p {
  font-size: 24px;
  color: #1a2332;
  min-height: 30px;
  margin-bottom: 10px;
  display: flex;
}
.Clear_all {
  position: absolute;
  right: 0px;
  font-size: 16px;
  z-index: 999;
  cursor: pointer;
}

.MainProducts {
  max-width: 280px;
  height: 28px;
  background: #f5f5f5;
  border-radius: 10px;
  border: 1px solid #009ea7;
  padding: 4px 6px 6px 6px;
  margin-bottom: 5px;
  color: #009ea7;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.MainProductsAll {
  min-width: 30px;
  height: 30px;
  background: #ddedee;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  color: #009ea7;
  cursor: pointer;
}

.MainProductsMainProducts {
  height: 35px;
  overflow: hidden;
}

.iconbgActiveBG {
  background: #ddedee;
}

.iconbgActiveBG .iconbgActive {
  background: #009ea7;
}

.iconbgActiveBG {
  margin-right: 0px;
  border-radius: 10px 0px 0px 10px;
}
/deep/ .el-scrollbar__wrap {
  max-width: 21rem !important;
}
.icon-dianhuaheshi {
  font-size: 26px;
}
.icon-gongyinglianyunyingnengli {
  font-size: 22px;
}
.icon-qushi {
  font-size: 28px;
}
.icon-shoucang {
  font-size: 26px;
}
.icon-arrowup-copy,
.icon-arrowup {
  font-size: 20px;
  margin-right: 10px;
}
.pTop5 {
  display: flex;
}
.pTop5Right {
  flex: 1;
}
.txtTop5 {
  min-width: 188px;
  height: 35px;
  line-height: 30px;
}
::v-deep .pTop5Right .el-popover__reference-wrapper {
  display: inline-block;
}

.profit-txt {
  width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  cursor: pointer;
  transform: rotate(0deg);
  color: #009ea7;
  font-size: 16px;
}

.bottom-list-echarts {
  /* padding-left: 2.8142857142857144rem; */
  display: flex;
  justify-content: space-between;
}

.bottom-list-echarts-li {
  padding: 1.4285714285714286rem;
  background: #fff;
  height: 18.571428571428573rem;
  /* flex: 1; */
  width: 33%;
  padding-bottom: 0.7142857142857143rem;
}

.icontransform {
  display: inline-block;
  transition: transform 0.5s ease;
  /* 设置过渡效果 */
  cursor: pointer;
}

.rotate {
  transform: rotate(-180deg);
  /* 旋转180度 */
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active 在 Vue 2.x 中 */ {
  opacity: 0;
  /* 初始透明度 */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
  /* 淡入淡出动画 */
}
.iconbgActive {
  background-color: #009ea7;
}

.bottom-list-echarts-li-left {
  border-right: 1px solid #dddddd;
  padding-right: 20px;
  width: 50%;
}

.bottom-list-echarts-li-right {
  padding-left: 20px;
  width: 50%;
}

.bottom-list-echarts-li-left-text {
  font-size: 14px;
  line-height: 30px;
  color: #1a2332;
  width: 100%;
  gap: 15px;
}

.bottom-list-echarts-head {
  font-size: 18px !important;
  color: #1a2332;
  font-family: "Arial bold";
}

.bottom-list-echarts-box {
  padding-top: 5px;
  margin-top: 5px;
  border-top: 1px solid #dddddd;
}

.news-text {
  font-size: 14px;
  color: #009ea7;
  margin-bottom: 10px;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.bottom-list-echarts-li ul {
  padding-top: 10px;
  border-top: 1px solid #dddddd;
  max-height: 73%;
  overflow: hidden;
}

.MoreCompany {
  font-size: 14px;
  color: #009ea7;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  text-decoration-line: underline;
}

.icon_sanjiaoLocation {
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: #000000;
  cursor: pointer;
}

@media (max-width: 1920px) {
  .left_menu_question p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .left_menu_question {
    margin-bottom: 7px;
    padding-bottom: 15px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 14px;
  }
  .trade_date_picker,
  .left_menu_context /deep/ .el-input__inner {
    height: 32px !important;
    font-size: 14px;
  }
  .trade_date_picker {
    width: 150px;
  }
  .trade_bottom_right_top {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .conpany-center-list {
    padding: 22px 15px 15px;
    margin-bottom: 7px;
  }
  .flex_center_between_box p {
    font-size: 18px;
    min-height: 22px;
    margin-bottom: 7px;
  }
  .indexPositonactive {
    margin-right: 7px;
    width: 22px;
  }
  .conpany-center-list-left {
    font-size: 18px;
  }
  .conpany-center-list-leftWith {
    width: calc(100% - 145px);
  }
  .conpany-center-list-left-box {
    width: calc(100% - 22px);
  }
  .icon-dianhuaheshi {
    font-size: 24px;
  }
  .icon-gongyinglianyunyingnengli {
    font-size: 20px;
  }
  .icon-qushi {
    font-size: 26px;
  }
  .icon-shoucang {
    font-size: 20px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 7px;
  }
  .list-text-color img {
    width: 28px;
    margin-right: 4px;
  }
  .list-text-color {
    font-size: 16px !important;
  }
  .iconbg {
    width: 37px;
    height: 37px;
  }
  .risk-right {
    width: 480px;
    padding: 15px;
    height: 608px;
  }
  .MainProducts {
    padding: 4px 5px 5px 5px;
  }
  .txtTop5 {
    min-width: 168px;
    height: 33px;
    line-height: 28px;
  }
  .left_menu_context-title {
    font-size: 16px;
    margin-bottom: 7px;
  }

  .icontransform {
    font-size: 12px;
  }

  .bottom-list-echarts {
    gap: 15px;
  }

  .bottom-list-echarts-li {
    padding: 15px 15px 7px;
    height: 240px;
  }

  .bottom-list-echarts-li-left {
    padding-right: 15px;
  }

  .bottom-list-echarts-li-right {
    padding-left: 15px;
  }

  .bottom-list-echarts-li-left-text {
    font-size: 14px;
    line-height: 30px;
    gap: 12px;
  }

  .Color009EA7 {
    font-size: 14px;
  }

  .bottom-list-echarts-head {
    font-size: 16px !important;
  }

  .news-text {
    font-size: 14px;
    margin-bottom: 7px;
  }

  .bottom-list-echarts-li ul {
    padding-top: 7px;
  }

  .MoreCompany {
    line-height: 20px;
  }

  .icon_sanjiaoLocation {
    bottom: 15px;
    right: 15px;
  }
}
@media screen and (max-width: 1439px) {
  .left_menu_question p {
    font-size: 14px;
    margin-bottom: 6px;
  }
  .left_menu_question {
    margin-bottom: 6px;
    padding-bottom: 13px;
  }
  .left_menu_context {
    margin-bottom: 20px;
  }
  .Clear_all {
    font-size: 12px;
  }
  .trade_bottom_right_top {
    margin-bottom: 6px;
    font-size: 12px;
  }
  .conpany-center-list {
    padding: 20px 13px 13px;
    margin-bottom: 6px;
  }
  .flex_center_between_box p {
    font-size: 16px;
    min-height: 20px;
    margin-bottom: 6px;
  }
  .indexPositonactive {
    margin-right: 6px;
    width: 20px;
  }
  .conpany-center-list-left {
    font-size: 16px;
  }
  .icon-dianhuaheshi {
    font-size: 20px;
  }
  .icon-gongyinglianyunyingnengli {
    font-size: 18px;
  }
  .icon-qushi {
    font-size: 22px;
  }
  .icon-shoucang {
    font-size: 18px;
  }
  .icon-arrowup-copy,
  .icon-arrowup {
    font-size: 16px;
    margin-right: 6px;
  }
  .list-text-color img {
    width: 24px;
    margin-right: 3px;
  }
  .list-text-color {
    font-size: 14px !important;
  }
  .iconbg {
    width: 33px;
    height: 33px;
  }
  .risk-right {
    width: 500px;
    padding: 13px;
    min-height: 42rem;
  }
  .MainProducts {
    padding: 4px 4px 4px 4px;
  }
  .txtTop5 {
    min-width: 146px;
    height: 33px;
    line-height: 28px;
  }
  .left_menu_context-title {
    font-size: 14px;
    margin-bottom: 6px;
  }

  .bottom-list-echarts {
    gap: 12px;
  }

  .bottom-list-echarts-li {
    padding: 12px 12px 6px;
  }

  .bottom-list-echarts-li-left {
    padding-right: 12px;
  }

  .bottom-list-echarts-li-right {
    padding-left: 12px;
  }

  .bottom-list-echarts-li-left-text {
    font-size: 12px;
    line-height: 26px;
    gap: 10px;
  }

  .Color009EA7 {
    font-size: 12px;
  }

  .bottom-list-echarts-head {
    font-size: 14px !important;
  }

  .news-text {
    font-size: 12px;
    margin-bottom: 6px;
  }

  .bottom-list-echarts-li ul {
    padding-top: 6px;
  }

  .MoreCompany {
    font-size: 12px;
    line-height: 16px;
  }

  .icon_sanjiaoLocation {
    bottom: 12px;
    right: 12px;
  }
}
</style>
